import { gql } from "@apollo/client";

export const SEARCH_COMPANY_QUERY = gql`
  query spogCompanySlim(
    $query: String!
    $per: Int
    $sort: [SearchCompaniesV2Sort]
  ) {
    searchCompaniesV2(query: $query, per: $per, sort: $sort) {
      count
      data {
        hgId
        name
        url
      }
    }
  }
`;
